module.exports = __webpack_public_path__ + "static/Moonlighter4-4a560f01a1e802daa89693368eff1fca.webp";